import { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Navbar from "./Navbar";
import { ReactComponent as PurchaseRequest } from "assets/Sidebar/PurchaseRequest.svg";
import { ReactComponent as TransferInventory } from "assets/Sidebar/TransferInventory.svg";
import { ReactComponent as Inventory } from "assets/Sidebar/Inventory.svg";
// import { ReactComponent as StockAdjustment } from "assets/Sidebar/StockAdjustment.svg";
// import { ReactComponent as StockOnHand } from "assets/Sidebar/StockOnHand.svg";
// import { ReactComponent as VendorManagement } from "assets/Sidebar/vendorManagement.svg";
import { ReactComponent as User } from "../assets/SideBarIcons/users.svg";
// import { ReactComponent as Warehouse } from '../assets/SideBarIcons/warehouse.svg'
import { ReactComponent as Vendor } from "../assets/SideBarIcons/vendor.svg";
import { ReactComponent as Units } from "../assets/SideBarIcons/units.svg";
import { ReactComponent as Store } from "../assets/SideBarIcons/store.svg";
import { ReactComponent as Services } from "../assets/SideBarIcons/services.svg";
import { ReactComponent as Station } from "../assets/SideBarIcons/station.svg";
import { ReactComponent as Pricelist } from "../assets/SideBarIcons/price-tag.svg";
import { ReactComponent as Roles } from "../assets/SideBarIcons/roles.svg";
import { ReactComponent as Bank } from "../assets/SideBarIcons/bank.svg";
import { ReactComponent as Bay } from "../assets/SideBarIcons/bay.svg";
import { ReactComponent as Business } from "../assets/SideBarIcons/business.svg";
import { ReactComponent as Client } from "../assets/SideBarIcons/customer.svg";
import { ReactComponent as Make } from "../assets/SideBarIcons/make.svg";
import { ReactComponent as Privileges } from "../assets/SideBarIcons/privileges.svg";
import { ReactComponent as Model } from "../assets/SideBarIcons/car-model.svg";
import { ReactComponent as Packages } from "../assets/SideBarIcons/pakage.svg";
import { ReactComponent as Inspection } from "../assets/SideBarIcons/inspection.svg";
// import { ReactComponent as StockTransfer } from '../assets/SideBarIcons/stock-transfer.svg'
// import { ReactComponent as Access } from "../assets/SideBarIcons/access.svg";
// import { ReactComponent as Definition } from "../assets/SideBarIcons/defination.svg";
// import { ReactComponent as MoneyTransfer } from "../assets/SideBarIcons/money-transfer.svg";
import { ReactComponent as Items } from "assets/SideBarIcons/items.svg";
import { ReactComponent as Status } from "../assets/SideBarIcons/status.svg";
import InventoryIcon from "@mui/icons-material/InventoryOutlined";
import ChecklistIcon from "@mui/icons-material/Checklist";
import DrawerComponent from "./Sidebar/components";
import AppRoutes from "Routes";
import { useLocation } from "react-router-dom";
import PageBreadcrumbs from "common/Breadcrumbs/PageBreadcrumbs";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import {
  CommonProfileService,
  NotificationProfileService,
  UserProfileService,
} from "subModule/src/core/services";
import { selectUserInfo, setUserInfo } from "features/user/userSlice";
import { LoginAsUserResponse } from "subModule/src/services/userProfile/interface";
import { enqueueSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { useDispatch, useSelector } from "react-redux";
import { GetBrandingResponse } from "subModule/src/services/allcommon/interface";
import { setBranding } from "features/server/brandingSlice";
import { themes } from "theme/themes";
import { useMediaQuery } from "@mui/material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { ActionsTypesResponse } from "subModule/src/services/Notifications/interface";
import { setActionTypes } from "features/user/actionSlice";
import { CheckUnreadCount } from "Helpers/CheckUnreadCount";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import store from "app/store";
import { clearSubscriptionStatuses } from "features/subscription/subscriptionSlice";
import {
  checkSubscriptions,
  checkSubscriptionFeatureItem,
  CheckSubscriptionStatuses,
} from "Helpers/CheckSubscriptions";
import { selectSubscriptionPlanMeta } from "features/subscription/subscriptionSlice";
import { fetchMediaAsObjectUrl } from "Helpers/mediaView";

const LOGIN_AS_BANNER_H = 40;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
interface LayoutComponentProps {
  handleLanguageSelect: (lang: string) => void;
}
const Layout: React.FC<LayoutComponentProps> = ({ handleLanguageSelect }) => {
  const { t } = useTranslation();
  const [navigation, setNavigation] = useState<any>([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const isLoginRoute = location.pathname === "/login";
  const isScreenLargeOrGreater = useMediaQuery("(min-width:1100px)");
  const [open, setOpen] = useState(true);
  const [themeColors, setThemeColors] = useState<any>({});
  const loggedInUserData = useSelector(selectUserInfo);
  const firstRender = useRef(true);
  const actionTypesFetched = useRef(false);
  const brandingMediaFiles = useRef<{
    logo: string;
    logInPageImage: string;
    favIcon: string;
  } | null>(null);
  const brandingMediaResolved = useRef(false);

  const { hasPlan: hasSubscriptionPlan } = useSelector(
    selectSubscriptionPlanMeta,
  );

  useEffect(() => {
    setOpen(isScreenLargeOrGreater);
  }, [isScreenLargeOrGreater]);
  useEffect(() => {
    if (!isLoginRoute) {
      fetchNavigationData();
      if (!actionTypesFetched.current) {
        actionTypesFetched.current = true;
        setTimeout(() => fetchActionTypes(), 1000);
      }
    }
  }, [isLoginRoute]);
  useEffect(() => {
    if (
      !localStorage.getItem("ACCESS_TOKEN") &&
      location.pathname !== "/login"
    ) {
      if (params.get("loginAsUser")) {
        LoginAs(params.get("loginAsUser"), params.get("auth"));
      } else {
        window.location.href = "/login";
      }
    } else if (
      localStorage.getItem("ACCESS_TOKEN") &&
      (location.pathname === "/" || location.pathname === "/login")
    ) {
      window.location.href = "/analytics";
    }
  }, []);
  useEffect(() => {
    const ownerToken = localStorage.getItem("loginAsOwnerToken");
    const accessToken = localStorage.getItem("ACCESS_TOKEN");
    if (ownerToken && accessToken && ownerToken === accessToken) {
      localStorage.removeItem("loginAsOwnerToken");
      localStorage.removeItem("loginAsOwnerUserInfo");
    }
  }, []);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      fetchBranding(window.location.host);
    }
  }, []);
  useEffect(() => {
    if (!isLoginRoute && loggedInUserData?.id) {
      CheckUnreadCount(loggedInUserData.id, dispatch, enqueueSnackbar);
      if (loggedInUserData?.type !== -1) {
        CheckSubscriptionStatuses(
          loggedInUserData?.business?.id,
          dispatch,
          enqueueSnackbar,
          fetchNavigationData,
        );
      }
    }
  }, [location, loggedInUserData?.id, hasSubscriptionPlan]);
  const fetchNavigationData = () => {
    const hasSubscriptionPlan = store.getState().subscriptions.hasPlan;
    const navigationData = {
      dashboard: {
        checked: true,
        title: "dashboard",
        icon: (
          <DashboardOutlinedIcon
            sx={{ fill: "black", width: "25px", height: "25px" }}
          />
        ),
        tooltip: "dashboard",
        subItems: {
          analytics: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("SALES_DASHBOARD")) &&
              checkPrivileges("ROLE_ANALYTICS_DASHBOARD"),
            title: "operationsOverview",
            href: "/analytics",
            icon: (
              <DashboardOutlinedIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "operationsOverview",
          },
          kpi_dashboard: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("KPIS_DASHBOARD")) &&
              checkPrivileges("ROLE_KPI_ANALYTICS_VIEW"),
            title: "servicekpi",
            href: "/analytics/kpis",
            icon: (
              <DashboardOutlinedIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "servicekpi",
          },
          inventory_dashboard: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptions("INVENTORY_DASHBOARD")) &&
              checkPrivileges("ROLE_INVENTORY_DASHBOARD"),
            title: "inventoryAnalytics",
            href: "/analytics/inventory",
            icon: (
              <DashboardOutlinedIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "inventoryAnalytics",
          },
          customer_analytics_dashboard: {
            checked: checkPrivileges("ROLE_ANALYTICS_DASHBOARD"),
            title: "customerAnalyticsDashboard",
            href: "/analytics/customer",
            icon: (
              <DashboardOutlinedIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "customerAnalyticsDashboard",
          },
          accounts_summary: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("ACCOUNT_MODULE")) &&
              checkPrivileges("ROLE_ACCOUNT_SUMMARY"),
            title: "accountsSummary",
            href: "/accounts-summary",
            icon: (
              <DashboardOutlinedIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "accountsSummary",
          },
        },
      },
      business_setup: {
        checked: true,
        title: "businessSetup",
        icon: <Business height={24} width={24} />,
        tooltip: "businessSetup",
        subItems: {
          business: {
            checked:
              (loggedInUserData?.type === -1 ||
                loggedInUserData?.type === 100) &&
              checkPrivileges("ROLE_BUSINESS_VIEW"),
            title: "businessDetails",
            href: "/businesses",
            icon: <Business height={24} width={24} />,
            tooltip: "businessDetails",
          },
          business_templates: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptions("CUSTOM_TEMPLATES")) &&
              checkPrivileges("ROLE_INVOICE_TEMPLATE_VIEW"),
            title: "businessTemplates",
            href: "/business-templates",
            icon: <Business height={24} width={24} />,
            tooltip: "businessTemplates",
          },
          bank_account: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("ACCOUNT_MODULE")) &&
              checkPrivileges("ROLE_BANKACCOUNT_VIEW"),
            href: "/accounts",
            icon: <Bank height={24} width={24} />,
            tooltip: "accounts",
            title: "accounts",
          },
          inter_account_transfer: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("ACCOUNT_MODULE")) &&
              checkPrivileges("ROLE_BANKACCOUNT_VIEW"),
            href: "/inter-account-transfers",
            icon: <Bank height={24} width={24} />,
            tooltip: "interAccountTransfers",
            title: "interAccountTransfers",
          },
          // bank_deposit: {
          //   checked: checkPrivileges("ROLE_BANKDEPOSIT_VIEW"),
          //   href: "/bank-deposits",
          //   icon: <Bank height={24} width={24} />,
          //   tooltip: "bankDeposits",
          //   title: "bankDeposits",
          // },
          business_group: {
            checked:
              loggedInUserData?.type === -1 &&
              checkPrivileges("ROLE_BUSINESSGROUP_VIEW"),
            title: "businessGroup",
            href: "/business-groups",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "businessGroup",
          },
          expenses: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptions("EXPENSE_MANAGEMENT")) &&
              checkPrivileges("ROLE_EXPENSE_MANAGER_VIEW"),
            title: "expenses",
            href: "/expenses",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "expenses",
          },
          expense_type: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptions("EXPENSE_MANAGEMENT")) &&
              checkPrivileges("ROLE_EXPENSE_TYPE_VIEW"),
            title: "Expense Types",
            href: "/expense-types",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "Expense Types",
          },
          taxprocedure: {
            checked: checkPrivileges("ROLE_TAXPROCEDURE_VIEW"),
            title: "taxProcedures",
            icon: <Inventory height={24} width={24} />,
            tooltip: "taxProcedures",
            href: "/tax-procedures",
          },
          cancellation_reasons: {
            checked: checkPrivileges("ROLE_CANCELLATION_REASON_VIEW"),
            title: "cancellationReasons",
            href: "/cancellation-reasons",
            icon: <Vendor height={24} width={24} />,
            tooltip: "cancellationReasons",
          },
          insurance_companies: {
            checked: checkPrivileges("ROLE_INSURANCECOMPANY_VIEW"),
            title: "insuranceCompanies",
            href: "/insurance-companies",
            icon: <Vendor height={24} width={24} />,
            tooltip: "insuranceCompanies",
          },
          hosting_details: {
            checked: loggedInUserData?.type === -1,
            title: "hostingDetails",
            href: "/hosting-details",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "hostingDetails",
          },
          subscription_plans: {
            checked:
              loggedInUserData?.type === -1 || loggedInUserData?.type === 100,
            title: "subscriptionPlans",
            href: "/subscription-plans",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "subscriptionPlans",
          },
        },
      },

      general: {
        checked: true,
        title: "general",
        icon: (
          <SummarizeOutlinedIcon
            sx={{ fill: "#000", fontSize: '25px', marginLeft: "-2px" }}
          />
        ),
        tooltip: "general",
        subItems: {
          units: {
            checked: checkPrivileges("ROLE_UNIT_VIEW"),
            title: "units",
            icon: <Units height={24} width={24} />,
            tooltip: "units",
            href: "/units",
          },
          status: {
            checked: checkPrivileges("ROLE_BUSINESSSTATUS_VIEW"),
            title: "Statuses",
            href: "/status/packages",
            icon: <Status height={24} width={24} />,
            tooltip: "Statuses",
          },
          inspection_form: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("INSPECTIONS")) &&
              checkPrivileges("ROLE_INSPECTIONFORM_VIEW"),
            href: "/inspection-forms",
            icon: <Inspection height={24} width={24} />,
            tooltip: "inspectionForms",
            title: "inspectionForms",
          },
          state: {
            checked: checkPrivileges("ROLE_STATE_VIEW"),
            title: "states",
            href: "/states",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "states",
          },
          checklist: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("CHECKLIST")) &&
              checkPrivileges("ROLE_CHECKLIST_VIEW"),
            title: "Checklists",
            href: "/checklists",
            icon: <ChecklistIcon height={24} width={24} />,
            tooltip: "Checklists",
          },
          users: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("USERS")) &&
              checkPrivileges("ROLE_USER_VIEW"),
            title: "users",
            icon: <User height={26} width={26} />,
            tooltip: "users",
            href: "/users",
          },
          role: {
            checked: checkPrivileges("ROLE_ROLE_VIEW"),
            href: "/roles",
            icon: <Roles height={24} width={24} />,
            tooltip: "Roles",
            title: "Roles",
          },
          user_group: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("USERS")) &&
              checkPrivileges("ROLE_USERGROUP_VIEW"),
            href: "/user-groups",
            icon: <PurchaseRequest height={24} width={24} />,
            tooltip: "usersGroup",
            title: "usersGroup",
          },
          client_group: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("CLIENT")) &&
              checkPrivileges("ROLE_CLIENTGROUP_VIEW"),
            href: "/client-groups",
            icon: <PurchaseRequest height={24} width={24} />,
            tooltip: "clientsGroup",
            title: "clientsGroup",
          },
          activity_logs: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("AUDIT_LOGS")) &&
              checkPrivileges("ROLE_REQUESTLOG_VIEW"),
            title: "ActivityLogs",
            href: "/activity-logs",
            icon: <ChecklistIcon height={24} width={24} />,
            tooltip: "ActivityLogs",
          },
          integration_logs: {
            checked: checkPrivileges("ROLE_INTEGRATION_LOG_VIEW"),
            title: "integrationLogs",
            href: "/integration-logs",
            icon: <ChecklistIcon height={24} width={24} />,
            tooltip: "integrationLogs",
          },
          manufacturer: {
            checked: checkPrivileges("ROLE_MANUFACTURER_VIEW"),
            href: "/manufacturers",
            icon: <Privileges height={24} width={24} />,
            tooltip: "manufacturers",
            title: "manufacturers",
          },
        },
      },

      items: {
        checked: true,
        title: "Items",
        icon: <Items height={23} width={23} />,
        tooltip: "Items",
        subItems: {
          parts: {
            checked: checkPrivileges("ROLE_ITEM_VIEW"),
            title: "items",
            href: "/parts",
            icon: <Inventory height={24} width={24} />,
            tooltip: "items",
          },
          service: {
            checked: checkPrivileges("ROLE_SERVICE_VIEW"),
            title: "services",
            href: "/services",
            icon: <Services height={24} width={24} />,
            tooltip: "services",
          },
          packages: {
            checked: checkPrivileges("ROLE_PACKAGE_VIEW"),
            title: "packages",
            href: "/packages",
            icon: <Packages height={24} width={24} />,
            tooltip: "packages",
          },
          itemgroup: {
            checked: checkPrivileges("ROLE_ITEMGROUP_VIEW"),
            href: "/parts-group",
            icon: <PurchaseRequest height={24} width={24} />,
            tooltip: "itemsGroup",
            title: "itemsGroup",
          },
          servicegroup: {
            checked: checkPrivileges("ROLE_SERVICEGROUP_VIEW"),
            href: "/services-group",
            icon: <PurchaseRequest height={24} width={24} />,
            tooltip: "servicesGroup",
            title: "servicesGroup",
          },
          packagegroup: {
            checked: checkPrivileges("ROLE_PACKAGEGROUP_VIEW"),
            href: "/packages-group",
            icon: <PurchaseRequest height={24} width={24} />,
            tooltip: "packagesGroup",
            title: "packagesGroup",
          },
          itemcategory: {
            checked: checkPrivileges("ROLE_ITEMCATEGORY_VIEW"),
            title: "itemsCategory",
            href: "/part-categories",
            icon: <Inventory height={24} width={24} />,
            tooltip: "itemsCategory",
          },
          price_list: {
            checked: checkPrivileges("ROLE_PRICELIST_VIEW"),
            title: "priceLists",
            href: "/price-lists",
            icon: <Pricelist height={24} width={24} />,
            tooltip: "priceLists",
          },
          // warehouse: {
          //   checked: checkPrivileges("ROLE_WAREHOUSE_VIEW"),
          //   title: "warehouses",
          //   href: "/warehouses",
          //   icon: <Warehouse height={24} width={24} />,
          //   tooltip: "warehouses",
          // },
        },
      },

      vehicle: {
        checked: !hasSubscriptionPlan || checkSubscriptions("VEHICLES"),
        title: "vehicles",
        icon: <Make height={23} width={23} />,
        tooltip: "vehicles",
        subItems: {
          vehicle: {
            checked: checkPrivileges("ROLE_VEHICLE_VIEW"),
            title: "vehiclesList",
            href: "/vehicles",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "vehiclesList",
          },
          make: {
            checked: checkPrivileges("ROLE_MAKE_VIEW"),
            title: "Makes",
            icon: <Make height={24} width={24} />,
            tooltip: "Makes",
            href: "/makes",
          },
          model: {
            checked: checkPrivileges("ROLE_MODEL_VIEW"),
            title: "Models",
            icon: <Model height={24} width={24} />,
            tooltip: "Models",
            href: "/models",
          },
          modelEngine: {
            checked: checkPrivileges("ROLE_MODELENGINE_VIEW"),
            title: "Model Engines",
            icon: <User height={24} width={24} />,
            tooltip: "Model Engines",
            href: "/model-engines",
          },
          vehicle_type: {
            checked: checkPrivileges("ROLE_VEHICLETYPE_VIEW"),
            title: "vehicleTypes",
            href: "/vehicle-types",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "vehicleTypes",
          },
          vehicle_status: {
            checked: checkPrivileges("ROLE_BUSINESSSTATUS_VIEW"),
            title: "VehicleStatuses",
            href: "/vehicle-statuses",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "VehicleStatuses",
          },
        },
      },

      customers: {
        checked: true,
        title: "customers",
        icon: <Client height={21} width={21} />,
        tooltip: "customers",
        subItems: {
          customersList: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("CLIENT")) &&
              checkPrivileges("ROLE_CLIENT_VIEW"),
            title: "customersList",
            icon: <Client height={24} width={24} />,
            tooltip: "customersList",
            href: "/clients",
          },
          // client: {
          //   checked: checkPrivileges("ROLE_CLIENT_VIEW"),
          //   title: "Clients",
          //   icon: <Client height={24} width={24} />,
          //   tooltip: "Clients",
          //   href: "/clients",
          // },
          estimate: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("ESTIMATES")) &&
              checkPrivileges("ROLE_ESTIMATION_VIEW"),
            title: "estimates",
            href: "/estimates",
            icon: <Bay height={24} width={24} />,
            tooltip: "estimates",
          },
          jobcard: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("JOB_CARDS")) &&
              checkPrivileges("ROLE_JOBCARD_VIEW"),
            title: "jobCards",
            href: "/job-cards",
            icon: <Bay height={24} width={24} />,
            tooltip: "jobCards",
          },
          workorder: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("WORK_ORDERS")) &&
              checkPrivileges("ROLE_WORKORDER_VIEW"),
            title: "workOrders",
            href: "/work-orders",
            icon: <Bay height={24} width={24} />,
            tooltip: "workOrder",
          },
          invoice: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("INVOICES")) &&
              checkPrivileges("ROLE_INVOICE_VIEW"),
            title: "invoices",
            href: "/invoices",
            icon: <Bay height={24} width={24} />,
            tooltip: "invoices",
          },
          inspections: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("INSPECTIONS")) &&
              checkPrivileges("ROLE_VEHICLEINSPECTION_VIEW"),
            title: "Inspections",
            href: "/inspections",
            icon: <Bay height={24} width={24} />,
            tooltip: "Inspections",
          },
          sales_credit_notes: {
            checked: checkPrivileges("ROLE_CREDITNOTE_VIEW"),
            title: "creditNotes",
            href: "/sales-credit-notes",
            icon: <Bay height={24} width={24} />,
            tooltip: "creditNotes",
          },
          payment: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("PAYMENT")) &&
              checkPrivileges("ROLE_PAYMENT_VIEW"),
            title: "payments",
            href: "/payments",
            icon: <Bay height={24} width={24} />,
            tooltip: "payments",
          },
          payment_mode: {
            checked: checkPrivileges("ROLE_PAYMENT_MODE_VIEW"),
            title: "Payment Modes",
            href: "/payment-modes",
            icon: <Bay height={24} width={24} />,
            tooltip: "Payment Modes",
          },
        },
      },

      suppliers: {
        checked: true,
        title: "vendors",
        icon: (
          <AccountTreeOutlinedIcon sx={{ fill: "#000", marginLeft: "-3px" }} />
        ),
        tooltip: "vendors",
        subItems: {
          vendor: {
            checked: checkPrivileges("ROLE_VENDOR_VIEW"),
            title: "suppliersList",
            href: "/suppliers",
            icon: <Vendor height={24} width={24} />,
            tooltip: "suppliersList",
          },
          purchase_order: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptionFeatureItem(
                  "INVENTORY_PURCHASING",
                  "PO FLOW",
                  ["RFQ", "DIRECT SR"],
                )) &&
              checkPrivileges("ROLE_PURCHASEORDER_VIEW"),
            title: "Purchase Orders",
            href: "/inventory/purchase-orders",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "Purchase Orders",
          },
          supplier_bill: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptions("INVENTORY_PURCHASING")) &&
              checkPrivileges("ROLE_PURCHASEINVOICE_VIEW"),
            title: "bills",
            href: "/inventory/supplier-bills",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "bills",
          },
          stock_received: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptionFeatureItem(
                  "INVENTORY_PURCHASING",
                  "DIRECT SR",
                  ["RFQ"],
                )) &&
              checkPrivileges("ROLE_STOCKRECEIPT_VIEW"),
            title: "Stock Received",
            href: "/inventory/stock-receives",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "Stock Received",
          },
          credit_note: {
            checked:
              (!hasSubscriptionPlan ||
                checkSubscriptions("INVENTORY_PURCHASING")) &&
              checkPrivileges("ROLE_PURCHASE_CREDITDEBITNOTE_VIEW"),
            title: "Debit Notes",
            href: "/inventory/debit-note",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "Debit Notes",
          },
          // unstock: {
          //   checked: checkPrivileges("ROLE_UNSTOCK_VIEW"),
          //   title: "Unstock",
          //   href: "/inventory/unstock",
          //   icon: (
          //     <InventoryIcon
          //       sx={{ fill: "black", width: "28px", height: "28px" }}
          //     />
          //   ),
          //   tooltip: "Unstock",
          // },
          supplier_payment: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("PAYMENT")) &&
              checkPrivileges("ROLE_PURCHASE_PAYMENT_VIEW"),
            title: "supplierPayments",
            href: "/inventory/supplier-payments",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "supplierPayments",
          },
        },
      },

      stations: {
        checked: true,
        title: "stations",
        icon: <Station height={21} width={21} />,
        tooltip: "stations",
        subItems: {
          station: {
            checked:
              // (!hasSubscriptionPlan || checkSubscriptions("STATIONS")) &&
              checkPrivileges("ROLE_STATION_VIEW"),
            title: "stationsList",
            href: "/stations",
            icon: <Station height={24} width={24} />,
            tooltip: "stationsList",
          },
          stationgroup: {
            checked:
              // (!hasSubscriptionPlan || checkSubscriptions("STATIONS")) &&
              checkPrivileges("ROLE_STATIONGROUP_VIEW"),
            title: "stationsGroup",
            href: "/station-groups",
            icon: <TransferInventory height={24} width={24} />,
            tooltip: "stationsGroup",
          },
          store: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("STORES")) &&
              checkPrivileges("ROLE_STORE_VIEW"),
            title: "stores",
            href: "/stores",
            icon: <Store height={24} width={24} />,
            tooltip: "stores",
          },
          bay: {
            checked:
              (!hasSubscriptionPlan || checkSubscriptions("BAYS")) &&
              checkPrivileges("ROLE_BAY_VIEW"),
            href: "/bays",
            icon: <Bay height={24} width={24} />,
            tooltip: "bays",
            title: "bays",
          },
        },
      },
      inventory: {
        checked: true,
        title: "Inventory",
        icon: (
          <InventoryIcon
            sx={{ fill: "black", width: "24px", height: "24px" }}
          />
        ),
        tooltip: "Inventory",
        subItems: {
          stock_level: {
            checked: checkPrivileges("ROLE_ITEM_VIEW"),
            title: "stockLevel",
            href: "/inventory/stock-level",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "stockLevel",
          },
          stock_adjustment: {
            checked: checkPrivileges("ROLE_INVENTORYADJUSTMENT_VIEW"),
            title: "StockAdjustments",
            href: "/inventory/stock-adjustments",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "StockAdjustments",
          },
          stock_transfer: {
            checked: checkPrivileges("ROLE_STOCKTRANSFER_VIEW"),
            title: "StockTransfers",
            href: "/inventory/stock-transfers",
            icon: (
              <InventoryIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "StockTransfers",
          },
        },
      },
      analytics: {
        checked: true,
        title: "reports",
        icon: (
          <AssessmentOutlinedIcon
            sx={{ fill: "black", width: "24px", height: "24px" }}
          />
        ),
        tooltip: "reports",
        subItems: {
          reports: {
            checked: true,
            title: "reports",
            href: "/reports",
            icon: (
              <AssessmentOutlinedIcon
                sx={{ fill: "black", width: "28px", height: "28px" }}
              />
            ),
            tooltip: "reports",
          },
        },
      },
    };
    setNavigation(navigationData);
  };
  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const loginAsOwnerToken = localStorage.getItem("loginAsOwnerToken");
  const loginAsOwnerUserInfo = localStorage.getItem("loginAsOwnerUserInfo");
  const accessToken = localStorage.getItem("ACCESS_TOKEN");
  const showLoginAsBar =
    !isLoginRoute &&
    !!loginAsOwnerToken &&
    !!loginAsOwnerUserInfo &&
    !!accessToken &&
    accessToken !== loginAsOwnerToken;

  const loginAsSecondaryBg =
    themeColors?.themeId === 100
      ? themeColors?.customTheme?.secondary
      : (themes as any)[themeColors?.themeId || 3]?.secondary;

  const handleBackToOwner = () => {
    const tok = localStorage.getItem("loginAsOwnerToken");
    const ui = localStorage.getItem("loginAsOwnerUserInfo");
    if (!tok || !ui) return;
    localStorage.setItem("ACCESS_TOKEN", tok);
    dispatch(setUserInfo(JSON.parse(ui)));
    localStorage.removeItem("loginAsOwnerToken");
    localStorage.removeItem("loginAsOwnerUserInfo");
    dispatch(clearSubscriptionStatuses());
    window.location.href = "/analytics";
  };

  const LoginAs = (
    loginToken: string | undefined | null,
    auth: string | undefined | null,
  ) => {
    UserProfileService.loginAsUser({ token: loginToken, authToken: auth })
      .then((res: LoginAsUserResponse) => {
        if (res.success) {
          if (auth) localStorage.setItem("loginAsOwnerToken", auth);
          dispatch(setUserInfo(res?.data as any));
          localStorage.setItem("selectedSubItem", "analytics");
          localStorage.setItem("ACCESS_TOKEN", res?.data?.accessToken || "");
          if (res?.data?.type === -1) {
            dispatch(clearSubscriptionStatuses());
            window.location.href = "/analytics";
          } else {
            CheckSubscriptionStatuses(
              res?.data?.business?.id,
              dispatch,
              enqueueSnackbar,
              () => {
                window.location.href = "/analytics";
              },
            );
          }
        } else {
          enqueueSnackbar(
            <AlertMessages text={res.message || "Something went wrong"} />,
            { variant: "error" },
          );
        }
      })
      .catch((err: any) => {
        console.error("===", err);
        enqueueSnackbar(
          <AlertMessages text={err?.data?.message || "Something went wrong"} />,
          { variant: "error" },
        );
      });
  };
  const applyBrandingFavicon = (favIcon: string) => {
    if (!favIcon) return;
    const link: HTMLLinkElement = document.querySelector(
      "link[rel~='icon']",
    ) as HTMLLinkElement;
    const link2: HTMLLinkElement = document.querySelector(
      "link[rel~='apple-touch-icon']",
    ) as HTMLLinkElement;
    if (link) link.href = favIcon;
    if (link2) link2.href = favIcon;
  };

  const patchBrandingAttr = (key: string, value: string) => {
    if (!value) return;
    const current = store.getState().branding as any;
    dispatch(
      setBranding({
        ...current,
        attributes: {
          ...(current?.attributes || {}),
          [key]: value,
        },
      }),
    );
    if (key === "favIcon") applyBrandingFavicon(value);
  };

  const resolveBrandingImages = () => {
    if (!brandingMediaFiles.current || brandingMediaResolved.current) {
      return;
    }
    brandingMediaResolved.current = true;
    const files = brandingMediaFiles.current;

    // Non-blocking + progressive: login UI paints immediately; images fill in as ready.
    // Logo first (above the fold), then background + favicon in parallel.
    void (async () => {
      if (files.logo) {
        patchBrandingAttr("logo", await fetchMediaAsObjectUrl(files.logo));
      }
      await Promise.all([
        files.logInPageImage
          ? fetchMediaAsObjectUrl(files.logInPageImage).then((src) =>
              patchBrandingAttr("logInPageImage", src),
            )
          : Promise.resolve(),
        files.favIcon
          ? fetchMediaAsObjectUrl(files.favIcon).then((src) =>
              patchBrandingAttr("favIcon", src),
            )
          : Promise.resolve(),
      ]);
    })();
  };

  const fetchBranding = async (url: string) => {
    await CommonProfileService.getBrandingDetails({ hostUrl: url })
      .then((res: GetBrandingResponse) => {
        if (res.success) {
          const attrs = res?.data?.attributes || {};
          brandingMediaFiles.current = {
            logo: (attrs as any)?.logo || "",
            logInPageImage: (attrs as any)?.logInPageImage || "",
            favIcon: (attrs as any)?.favIcon || "",
          };
          brandingMediaResolved.current = false;
          dispatch(setBranding(res?.data || {}));
          setThemeColors(attrs || {});
          document.title = (attrs as any)?.serviceTitle || "CMS";
          const styleSheet = document.createElement("style");
          styleSheet.innerHTML = `
          ::-webkit-scrollbar {
            background-color: ${((attrs as any)?.themeId === 100 ? ((attrs as any)?.customTheme as any)?.secondary : (themes as any)[(attrs as any)?.themeId || 3]?.secondary) || "#FC5F3A"};
          }
          ::-webkit-scrollbar-thumb {
            background: ${((attrs as any)?.themeId === 100 ? ((attrs as any)?.customTheme as any)?.primary : (themes as any)[(attrs as any)?.themeId || 3]?.primary) || "rgba(76, 0, 85, 0.5)"};
          }
          ::-webkit-scrollbar-thumb:hover {
            background: ${((attrs as any)?.themeId === 100 ? ((attrs as any)?.customTheme as any)?.primary : (themes as any)[(attrs as any)?.themeId || 3]?.primary) || "rgba(76, 0, 85, 0.5)"};
          }
        `;
          document.head.appendChild(styleSheet);
          resolveBrandingImages();
        } else {
          document.title = "CMS";
        }
      })
      .catch((err: any) => {
        console.error("===", err);
        document.title = "CMS";
      });
  };
  const fetchActionTypes = () => {
    NotificationProfileService.getActionsType()
      .then((res: ActionsTypesResponse) => {
        dispatch(
          setActionTypes(
            res || {
              actions: {},
              types: {},
            },
          ),
        );
      })
      .catch((err: any) => {
        dispatch(
          setActionTypes({
            actions: {},
            types: {},
          }),
        );
        console.error("===", err);
      });
  };
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <CssBaseline />
      {showLoginAsBar && (
        <Box
          className="hide-on-print"
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.drawer + 2,
            minHeight: LOGIN_AS_BANNER_H,
            px: 2,
            py: 0.75,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            bgcolor: loginAsSecondaryBg,
            color: "#fff",
          }}
        >
          <span className="font-Saira text-sm md:text-base">
            {t("loginAsUserBanner")}
          </span>
          <Button
            color="inherit"
            size="small"
            onClick={handleBackToOwner}
            sx={{ color: "#fff", fontWeight: 600, whiteSpace: "nowrap" }}
          >
            {t("loginAsUserBackToOwner")}
          </Button>
        </Box>
      )}
      {/* Navabr */}
      {!isLoginRoute && (
        <Navbar
          onMenuClick={handleDrawerOpen}
          handleLanguageSelect={handleLanguageSelect}
          stackTopOffset={showLoginAsBar ? LOGIN_AS_BANNER_H : 0}
          navigation={navigation}
        />
      )}
      {/* Sidebar */}
      {!isLoginRoute && (
        <DrawerComponent
          open={open}
          navigation={navigation}
          stackTopOffset={showLoginAsBar ? LOGIN_AS_BANNER_H : 0}
          drawerHeader={<DrawerHeader />}
          themeColors={
            themeColors?.themeId === 100
              ? themeColors?.customTheme
              : (themes as any)[themeColors?.themeId || 3]
          }
          isScreenLargeOrGreater={isScreenLargeOrGreater}
        />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          height: "100vh",
          overflow: "auto",
          p: isLoginRoute ? 0 : 2,
          background:
            themeColors?.themeId === 100
              ? themeColors?.customTheme.appBg
              : (themes as any)[themeColors?.themeId || 3]?.appBg,
        }}
      >
        {!isLoginRoute && (
          <DrawerHeader
            className="hide-on-print"
            style={
              showLoginAsBar ? { marginTop: LOGIN_AS_BANNER_H } : undefined
            }
          />
        )}
        {/* Inner Components */}
        {!isLoginRoute ? <PageBreadcrumbs /> : null}
        <AppRoutes />
      </Box>
    </Box>
  );
};
export default Layout;
